import * as Sentry from "@sentry/nextjs";

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

	// Performance Monitoring
	tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring

	// Session Replay - captures what users see when errors happen
	replaysSessionSampleRate: 0.1, // Capture 10% of sessions
	replaysOnErrorSampleRate: 1.0, // Capture 100% of sessions with errors

	// Set environment
	environment: process.env.NODE_ENV,

	// Enable if DSN is configured and NOT in development
	enabled:
		!!process.env.NEXT_PUBLIC_SENTRY_DSN &&
		process.env.NODE_ENV !== "development",

	// Capture unhandled promise rejections
	integrations: [
		Sentry.replayIntegration({
			// Mask all text and block all media for privacy
			maskAllText: false,
			blockAllMedia: false,
		}),
	],

	// Filter out noise
	ignoreErrors: [
		// Browser extensions
		"chrome-extension://",
		"moz-extension://",
		"top.GLOBALS",
		"originalCreateNotification",
		"canvas.contentDocument",
		"MyApp_RemoveAllHighlights",
		"http://tt.teleport.top",
		"jigsaw",
		"fb_xd_fragment",
		/extensions\//i,
		/^chrome:\/\//i,
		// Network errors that aren't actionable
		"Failed to fetch",
		"Network request failed",
		"NetworkError",
		"AbortError",
		"Load failed",
		// Ignore ResizeObserver errors (common false positive)
		"ResizeObserver loop limit exceeded",
		"ResizeObserver loop completed with undelivered notifications",
		// Google Analytics failures (not our problem)
		"google-analytics.com",
		"googletagmanager.com",
	],

	// Don't send errors from browser extensions
	denyUrls: [
		/extensions\//i,
		/^chrome:\/\//i,
		/^chrome-extension:\/\//i,
		/^moz-extension:\/\//i,
		/^safari-extension:\/\//i,
	],

	// Add extra context to errors
	beforeSend(event) {
		// Add current URL
		if (typeof window !== "undefined") {
			event.tags = {
				...event.tags,
				url: window.location.href,
			};
		}
		return event;
	},
});

// Export for router transition tracing (required for Next.js App Router)
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
